module.exports = __webpack_public_path__ + "img/sealCheck.7dfb2ecf.svg";